export type ClassValue = string | false | null | undefined;

/** Joins conditional class names; the single place class merging happens. */
export function cx(...values: ClassValue[]): string {
  return values.filter(Boolean).join(" ");
}
